import {
    EDAP_EVENT_DATA_FIELDS,
    EDAP_FIELD_TO_CAROUSEL_FIELD_MAP,
    EVENT_TYPES,
} from './edapEventsConstants';

export const transformCarouselDataToEventFields = (fieldList = []) => (
    eventOptions = {}
) => {
    const {carouselData} = eventOptions;
    const eventFields = fieldList.reduce((edapFields, nextField) => {
        const carouselField = EDAP_FIELD_TO_CAROUSEL_FIELD_MAP[nextField];

        if (carouselData[carouselField]) {
            edapFields[nextField] = carouselData[carouselField];
        }

        return edapFields;
    }, {});

    return {
        ...eventOptions,
        eventFields,
    };
};

export const getEventName = (eventType, carouselType) => (eventOptions) => {
    const eventName = `${
        eventType === EVENT_TYPES.SELECTED
            ? `${carouselType}_result`
            : carouselType
    }.${eventType}`;

    return {
        eventName,
        ...eventOptions,
    };
};

export const triggerEdapEvent = ({
    context,
    eventName,
    eventFields,
    eventOptions = {},
} = {}) => {
    const shouldFire =
        eventName &&
        eventFields &&
        eventFields[EDAP_EVENT_DATA_FIELDS.RECOMMENDATION_REQUEST_MARKER];

    if (shouldFire) {
        if (context.hasProvider) {
            context.trigger(eventName, eventFields, eventOptions);
        } else {
            window.edap = window.edap || [];
            window.edap.push((edap) => {
                edap.trigger(eventName, eventFields, eventOptions);
            });
        }
    }
};
